// extracted by mini-css-extract-plugin
export default {"skeletonTable":"SkeletonTable_skeletonTable__3mVs5","skeletonRow":"SkeletonTable_skeletonRow__kIy5Y","shimmer":"SkeletonTable_shimmer__yEqXr"};